// extracted by css-extract-rspack-plugin
export default {"buttonWrapper":"buttonWrapper-J6L475"};